// https://cookieconsent.orestbida.com
//import * as CookieConsent from 'vanilla-cookieconsent';
/*!
* CookieConsent 3.1.0
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/ const $4c08ceecfc768f1b$var$e = 'opt-in', $4c08ceecfc768f1b$var$t = 'opt-out', $4c08ceecfc768f1b$var$o = 'show--consent', $4c08ceecfc768f1b$var$n = 'show--preferences', $4c08ceecfc768f1b$var$a = 'disable--interaction', $4c08ceecfc768f1b$var$s = 'data-category', $4c08ceecfc768f1b$var$c = 'div', $4c08ceecfc768f1b$var$r = 'button', $4c08ceecfc768f1b$var$i = 'aria-hidden', $4c08ceecfc768f1b$var$l = 'btn-group', $4c08ceecfc768f1b$var$d = 'click', $4c08ceecfc768f1b$var$f = 'data-role', $4c08ceecfc768f1b$var$_ = 'consentModal', $4c08ceecfc768f1b$var$u = 'preferencesModal';
class $4c08ceecfc768f1b$var$p {
    constructor(){
        this.t = {
            mode: $4c08ceecfc768f1b$var$e,
            revision: 0,
            autoShow: !0,
            lazyHtmlGeneration: !0,
            autoClearCookies: !0,
            manageScriptTags: !0,
            hideFromBots: !0,
            cookie: {
                name: 'cc_cookie',
                expiresAfterDays: 182,
                domain: '',
                path: '/',
                secure: !0,
                sameSite: 'Lax'
            }
        }, this.o = {
            i: {},
            l: '',
            _: {},
            u: {},
            p: {},
            m: [],
            v: !1,
            h: null,
            C: null,
            S: null,
            M: '',
            D: !0,
            T: !1,
            k: !1,
            A: !1,
            N: !1,
            H: [],
            V: !1,
            I: !0,
            L: [],
            j: !1,
            F: '',
            P: !1,
            O: [],
            R: [],
            B: [],
            $: [],
            G: !1,
            J: !1,
            U: !1,
            q: [],
            K: [],
            W: [],
            X: {},
            Y: {},
            Z: {},
            ee: {},
            te: {},
            oe: []
        }, this.ne = {
            ae: {},
            se: {}
        }, this.ce = {}, this.re = {
            ie: 'cc:onFirstConsent',
            le: 'cc:onConsent',
            de: 'cc:onChange',
            fe: 'cc:onModalShow',
            _e: 'cc:onModalHide',
            ue: 'cc:onModalReady'
        };
    }
}
const $4c08ceecfc768f1b$var$g = new $4c08ceecfc768f1b$var$p, $4c08ceecfc768f1b$var$m = (e, t)=>e.indexOf(t), $4c08ceecfc768f1b$var$b = (e, t)=>-1 !== $4c08ceecfc768f1b$var$m(e, t), $4c08ceecfc768f1b$var$v = (e)=>Array.isArray(e), $4c08ceecfc768f1b$var$y = (e)=>'string' == typeof e, $4c08ceecfc768f1b$var$h = (e)=>!!e && 'object' == typeof e && !$4c08ceecfc768f1b$var$v(e), $4c08ceecfc768f1b$var$C = (e)=>'function' == typeof e, $4c08ceecfc768f1b$var$w = (e)=>Object.keys(e), $4c08ceecfc768f1b$var$S = (e)=>Array.from(new Set(e)), $4c08ceecfc768f1b$var$x = ()=>document.activeElement, $4c08ceecfc768f1b$var$M = (e)=>e.preventDefault(), $4c08ceecfc768f1b$var$D = (e, t)=>e.querySelectorAll(t), $4c08ceecfc768f1b$var$T = (e)=>e.dispatchEvent(new Event('change')), $4c08ceecfc768f1b$var$k = (e)=>{
    const t = document.createElement(e);
    return e === $4c08ceecfc768f1b$var$r && (t.type = e), t;
}, $4c08ceecfc768f1b$var$E = (e, t, o)=>e.setAttribute(t, o), $4c08ceecfc768f1b$var$A = (e, t, o)=>{
    e.removeAttribute(o ? 'data-' + t : t);
}, $4c08ceecfc768f1b$var$N = (e, t, o)=>e.getAttribute(o ? 'data-' + t : t), $4c08ceecfc768f1b$var$H = (e, t)=>e.appendChild(t), $4c08ceecfc768f1b$var$V = (e, t)=>e.classList.add(t), $4c08ceecfc768f1b$var$I = (e, t)=>$4c08ceecfc768f1b$var$V(e, 'cm__' + t), $4c08ceecfc768f1b$var$L = (e, t)=>$4c08ceecfc768f1b$var$V(e, 'pm__' + t), $4c08ceecfc768f1b$var$j = (e, t)=>e.classList.remove(t), $4c08ceecfc768f1b$var$F = (e)=>{
    if ('object' != typeof e) return e;
    if (e instanceof Date) return new Date(e.getTime());
    let t = Array.isArray(e) ? [] : {};
    for(let o in e){
        let n = e[o];
        t[o] = $4c08ceecfc768f1b$var$F(n);
    }
    return t;
}, $4c08ceecfc768f1b$var$P = ()=>{
    const e = {}, { O: t, X: o, Y: n } = $4c08ceecfc768f1b$var$g.o;
    for (const a of t)e[a] = $4c08ceecfc768f1b$var$$(n[a], $4c08ceecfc768f1b$var$w(o[a]));
    return e;
}, $4c08ceecfc768f1b$var$O = (e, t)=>dispatchEvent(new CustomEvent(e, {
        detail: t
    })), $4c08ceecfc768f1b$var$R = (e, t, o, n)=>{
    e.addEventListener(t, o), n && $4c08ceecfc768f1b$var$g.o.m.push({
        pe: e,
        ge: t,
        me: o
    });
}, $4c08ceecfc768f1b$var$B = ()=>{
    const e = $4c08ceecfc768f1b$var$g.t.cookie.expiresAfterDays;
    return $4c08ceecfc768f1b$var$C(e) ? e($4c08ceecfc768f1b$var$g.o.F) : e;
}, $4c08ceecfc768f1b$var$$ = (e, t)=>{
    const o = e || [], n = t || [];
    return o.filter((e)=>!$4c08ceecfc768f1b$var$b(n, e)).concat(n.filter((e)=>!$4c08ceecfc768f1b$var$b(o, e)));
}, $4c08ceecfc768f1b$var$G = (e)=>{
    $4c08ceecfc768f1b$var$g.o.R = $4c08ceecfc768f1b$var$S(e), $4c08ceecfc768f1b$var$g.o.F = (()=>{
        let e = 'custom';
        const { R: t, O: o, B: n } = $4c08ceecfc768f1b$var$g.o, a = t.length;
        return a === o.length ? e = 'all' : a === n.length && (e = 'necessary'), e;
    })();
}, $4c08ceecfc768f1b$var$J = (e, t, o, n)=>{
    const a = 'accept-', { show: s, showPreferences: c, hide: r, hidePreferences: i, acceptCategory: l } = t, f = e || document, _ = (e)=>$4c08ceecfc768f1b$var$D(f, `[data-cc="${e}"]`), u = (e, t)=>{
        $4c08ceecfc768f1b$var$M(e), l(t), i(), r();
    }, p = _('show-preferencesModal'), m = _('show-consentModal'), b = _(a + 'all'), v = _(a + 'necessary'), y = _(a + 'custom'), h = $4c08ceecfc768f1b$var$g.t.lazyHtmlGeneration;
    for (const e of p)$4c08ceecfc768f1b$var$E(e, 'aria-haspopup', 'dialog'), $4c08ceecfc768f1b$var$R(e, $4c08ceecfc768f1b$var$d, (e)=>{
        $4c08ceecfc768f1b$var$M(e), c();
    }), h && ($4c08ceecfc768f1b$var$R(e, 'mouseenter', (e)=>{
        $4c08ceecfc768f1b$var$M(e), $4c08ceecfc768f1b$var$g.o.N || o(t, n);
    }, !0), $4c08ceecfc768f1b$var$R(e, 'focus', ()=>{
        $4c08ceecfc768f1b$var$g.o.N || o(t, n);
    }));
    for (let e of m)$4c08ceecfc768f1b$var$E(e, 'aria-haspopup', 'dialog'), $4c08ceecfc768f1b$var$R(e, $4c08ceecfc768f1b$var$d, (e)=>{
        $4c08ceecfc768f1b$var$M(e), s(!0);
    }, !0);
    for (let e of b)$4c08ceecfc768f1b$var$R(e, $4c08ceecfc768f1b$var$d, (e)=>{
        u(e, 'all');
    }, !0);
    for (let e of y)$4c08ceecfc768f1b$var$R(e, $4c08ceecfc768f1b$var$d, (e)=>{
        u(e);
    }, !0);
    for (let e of v)$4c08ceecfc768f1b$var$R(e, $4c08ceecfc768f1b$var$d, (e)=>{
        u(e, []);
    }, !0);
}, $4c08ceecfc768f1b$var$U = (e, t)=>{
    e && (t && (e.tabIndex = -1), e.focus(), t && e.removeAttribute('tabindex'));
}, $4c08ceecfc768f1b$var$z = (e, t)=>{
    const o = (n)=>{
        n.target.removeEventListener('transitionend', o), 'opacity' === n.propertyName && '1' === getComputedStyle(e).opacity && $4c08ceecfc768f1b$var$U(((e)=>1 === e ? $4c08ceecfc768f1b$var$g.ne.be : $4c08ceecfc768f1b$var$g.ne.ve)(t));
    };
    $4c08ceecfc768f1b$var$R(e, 'transitionend', o);
};
let $4c08ceecfc768f1b$var$q;
const $4c08ceecfc768f1b$var$K = (e)=>{
    clearTimeout($4c08ceecfc768f1b$var$q), e ? $4c08ceecfc768f1b$var$V($4c08ceecfc768f1b$var$g.ne.ye, $4c08ceecfc768f1b$var$a) : $4c08ceecfc768f1b$var$q = setTimeout(()=>{
        $4c08ceecfc768f1b$var$j($4c08ceecfc768f1b$var$g.ne.ye, $4c08ceecfc768f1b$var$a);
    }, 500);
}, $4c08ceecfc768f1b$var$Q = [
    'M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5',
    'M 3.572 13.406 L 8.281 18.115 L 20.428 5.885',
    'M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 '
], $4c08ceecfc768f1b$var$W = (e = 0, t = 1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${$4c08ceecfc768f1b$var$Q[e]}"/></svg>`, $4c08ceecfc768f1b$var$X = (e)=>{
    const t = $4c08ceecfc768f1b$var$g.ne, o = $4c08ceecfc768f1b$var$g.o;
    ((e)=>{
        const n = e === t.he, a = o.i.disablePageInteraction ? t.ye : n ? t.Ce : t.ye;
        $4c08ceecfc768f1b$var$R(a, 'keydown', (t)=>{
            if ('Tab' !== t.key || !(n ? o.k && !o.A : o.A)) return;
            const a = $4c08ceecfc768f1b$var$x(), s = n ? o.q : o.K;
            0 !== s.length && (t.shiftKey ? a !== s[0] && e.contains(a) || ($4c08ceecfc768f1b$var$M(t), $4c08ceecfc768f1b$var$U(s[1])) : a !== s[1] && e.contains(a) || ($4c08ceecfc768f1b$var$M(t), $4c08ceecfc768f1b$var$U(s[0])));
        }, !0);
    })(e);
}, $4c08ceecfc768f1b$var$Y = [
    '[href]',
    $4c08ceecfc768f1b$var$r,
    'input',
    'details',
    '[tabindex]'
].map((e)=>e + ':not([tabindex="-1"])').join(','), $4c08ceecfc768f1b$var$Z = (e)=>{
    const { o: t, ne: o } = $4c08ceecfc768f1b$var$g, n = (e, t)=>{
        const o = $4c08ceecfc768f1b$var$D(e, $4c08ceecfc768f1b$var$Y);
        t[0] = o[0], t[1] = o[o.length - 1];
    };
    1 === e && t.T && n(o.he, t.q), 2 === e && t.N && n(o.we, t.K);
}, $4c08ceecfc768f1b$var$ee = (e, t, o)=>{
    const { de: n, le: a, ie: s, _e: c, ue: r, fe: i } = $4c08ceecfc768f1b$var$g.ce, l = $4c08ceecfc768f1b$var$g.re;
    if (t) {
        const n = {
            modalName: t
        };
        return e === l.fe ? $4c08ceecfc768f1b$var$C(i) && i(n) : e === l._e ? $4c08ceecfc768f1b$var$C(c) && c(n) : (n.modal = o, $4c08ceecfc768f1b$var$C(r) && r(n)), $4c08ceecfc768f1b$var$O(e, n);
    }
    const d = {
        cookie: $4c08ceecfc768f1b$var$g.o.p
    };
    e === l.ie ? $4c08ceecfc768f1b$var$C(s) && s($4c08ceecfc768f1b$var$F(d)) : e === l.le ? $4c08ceecfc768f1b$var$C(a) && a($4c08ceecfc768f1b$var$F(d)) : (d.changedCategories = $4c08ceecfc768f1b$var$g.o.L, d.changedServices = $4c08ceecfc768f1b$var$g.o.ee, $4c08ceecfc768f1b$var$C(n) && n($4c08ceecfc768f1b$var$F(d))), $4c08ceecfc768f1b$var$O(e, $4c08ceecfc768f1b$var$F(d));
}, $4c08ceecfc768f1b$var$te = (e, t)=>{
    try {
        return e();
    } catch (e) {
        return !t && console.warn('CookieConsent:', e), !1;
    }
}, $4c08ceecfc768f1b$var$oe = (e)=>{
    const { Y: t, ee: o, O: n, X: a, oe: c, p: r, L: i } = $4c08ceecfc768f1b$var$g.o;
    for (const e of n){
        const n = o[e] || t[e] || [];
        for (const o of n){
            const n = a[e][o];
            if (!n) continue;
            const { onAccept: s, onReject: c } = n;
            !n.Se && $4c08ceecfc768f1b$var$b(t[e], o) ? (n.Se = !0, $4c08ceecfc768f1b$var$C(s) && s()) : n.Se && !$4c08ceecfc768f1b$var$b(t[e], o) && (n.Se = !1, $4c08ceecfc768f1b$var$C(c) && c());
        }
    }
    if (!$4c08ceecfc768f1b$var$g.t.manageScriptTags) return;
    const l = c, d = e || r.categories || [], f = (e, n)=>{
        if (n >= e.length) return;
        const a = c[n];
        if (a.xe) return f(e, n + 1);
        const r = a.Me, l = a.De, _ = a.Te, u = $4c08ceecfc768f1b$var$b(d, l), p = !!_ && $4c08ceecfc768f1b$var$b(t[l], _);
        if (!_ && !a.ke && u || !_ && a.ke && !u && $4c08ceecfc768f1b$var$b(i, l) || _ && !a.ke && p || _ && a.ke && !p && $4c08ceecfc768f1b$var$b(o[l] || [], _)) {
            a.xe = !0;
            const t = $4c08ceecfc768f1b$var$N(r, 'type', !0);
            $4c08ceecfc768f1b$var$A(r, 'type', !!t), $4c08ceecfc768f1b$var$A(r, $4c08ceecfc768f1b$var$s);
            let o = $4c08ceecfc768f1b$var$N(r, 'src', !0);
            o && $4c08ceecfc768f1b$var$A(r, 'src', !0);
            const c = $4c08ceecfc768f1b$var$k('script');
            c.textContent = r.innerHTML;
            for (const { nodeName: e } of r.attributes)$4c08ceecfc768f1b$var$E(c, e, r[e] || $4c08ceecfc768f1b$var$N(r, e));
            t && (c.type = t), o ? c.src = o : o = r.src;
            const i = !!o && (!t || [
                'text/javascript',
                'module'
            ].includes(t));
            if (i && (c.onload = c.onerror = ()=>{
                f(e, ++n);
            }), r.replaceWith(c), i) return;
        }
        f(e, ++n);
    };
    f(l, 0);
}, $4c08ceecfc768f1b$var$ne = 'bottom', $4c08ceecfc768f1b$var$ae = 'left', $4c08ceecfc768f1b$var$se = 'center', $4c08ceecfc768f1b$var$ce = 'right', $4c08ceecfc768f1b$var$re = 'inline', $4c08ceecfc768f1b$var$ie = 'wide', $4c08ceecfc768f1b$var$le = 'pm--', $4c08ceecfc768f1b$var$de = [
    'middle',
    'top',
    $4c08ceecfc768f1b$var$ne
], $4c08ceecfc768f1b$var$fe = [
    $4c08ceecfc768f1b$var$ae,
    $4c08ceecfc768f1b$var$se,
    $4c08ceecfc768f1b$var$ce
], $4c08ceecfc768f1b$var$_e = {
    box: {
        Ee: [
            $4c08ceecfc768f1b$var$ie,
            $4c08ceecfc768f1b$var$re
        ],
        Ae: $4c08ceecfc768f1b$var$de,
        Ne: $4c08ceecfc768f1b$var$fe,
        He: $4c08ceecfc768f1b$var$ne,
        Ve: $4c08ceecfc768f1b$var$ce
    },
    cloud: {
        Ee: [
            $4c08ceecfc768f1b$var$re
        ],
        Ae: $4c08ceecfc768f1b$var$de,
        Ne: $4c08ceecfc768f1b$var$fe,
        He: $4c08ceecfc768f1b$var$ne,
        Ve: $4c08ceecfc768f1b$var$se
    },
    bar: {
        Ee: [
            $4c08ceecfc768f1b$var$re
        ],
        Ae: $4c08ceecfc768f1b$var$de.slice(1),
        Ne: [],
        He: $4c08ceecfc768f1b$var$ne,
        Ve: ''
    }
}, $4c08ceecfc768f1b$var$ue = {
    box: {
        Ee: [],
        Ae: [],
        Ne: [],
        He: '',
        Ve: ''
    },
    bar: {
        Ee: [
            $4c08ceecfc768f1b$var$ie
        ],
        Ae: [],
        Ne: [
            $4c08ceecfc768f1b$var$ae,
            $4c08ceecfc768f1b$var$ce
        ],
        He: '',
        Ve: $4c08ceecfc768f1b$var$ae
    }
}, $4c08ceecfc768f1b$var$pe = (e)=>{
    const t = $4c08ceecfc768f1b$var$g.o.i.guiOptions, o = t && t.consentModal, n = t && t.preferencesModal;
    0 === e && $4c08ceecfc768f1b$var$ge($4c08ceecfc768f1b$var$g.ne.he, $4c08ceecfc768f1b$var$_e, o, 'cm--', 'box', 'cm'), 1 === e && $4c08ceecfc768f1b$var$ge($4c08ceecfc768f1b$var$g.ne.we, $4c08ceecfc768f1b$var$ue, n, $4c08ceecfc768f1b$var$le, 'box', 'pm');
}, $4c08ceecfc768f1b$var$ge = (e, t, o, n, a, s)=>{
    e.className = s;
    const c = o && o.layout, r = o && o.position, i = o && o.flipButtons, l = !o || !1 !== o.equalWeightButtons, d = c && c.split(' ') || [], f = d[0], _ = d[1], u = f in t ? f : a, p = t[u], m = $4c08ceecfc768f1b$var$b(p.Ee, _) && _, v = r && r.split(' ') || [], y = v[0], h = n === $4c08ceecfc768f1b$var$le ? v[0] : v[1], C = $4c08ceecfc768f1b$var$b(p.Ae, y) ? y : p.He, w = $4c08ceecfc768f1b$var$b(p.Ne, h) ? h : p.Ve, S = (t)=>{
        t && $4c08ceecfc768f1b$var$V(e, n + t);
    };
    S(u), S(m), S(C), S(w), i && S('flip');
    const x = s + '__btn--secondary';
    if ('cm' === s) {
        const { Ie: e, Le: t } = $4c08ceecfc768f1b$var$g.ne;
        e && (l ? $4c08ceecfc768f1b$var$j(e, x) : $4c08ceecfc768f1b$var$V(e, x)), t && (l ? $4c08ceecfc768f1b$var$j(t, x) : $4c08ceecfc768f1b$var$V(t, x));
    } else {
        const { je: e } = $4c08ceecfc768f1b$var$g.ne;
        e && (l ? $4c08ceecfc768f1b$var$j(e, x) : $4c08ceecfc768f1b$var$V(e, x));
    }
}, $4c08ceecfc768f1b$var$me = (e, t)=>{
    const o = $4c08ceecfc768f1b$var$g.o, n = $4c08ceecfc768f1b$var$g.ne, { hide: a, hidePreferences: s, acceptCategory: _ } = e, p = (e)=>{
        _(e), s(), a();
    }, m = o.u && o.u.preferencesModal;
    if (!m) return;
    const b = m.title, v = m.closeIconLabel, C = m.acceptAllBtn, S = m.acceptNecessaryBtn, x = m.savePreferencesBtn, M = m.sections || [], D = C || S || x;
    if (n.Fe) n.Pe = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$L(n.Pe, 'body');
    else {
        n.Fe = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$V(n.Fe, 'pm-wrapper');
        const e = $4c08ceecfc768f1b$var$k('div');
        $4c08ceecfc768f1b$var$V(e, 'pm-overlay'), $4c08ceecfc768f1b$var$H(n.Fe, e), $4c08ceecfc768f1b$var$R(e, $4c08ceecfc768f1b$var$d, s), n.we = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$V(n.we, 'pm'), $4c08ceecfc768f1b$var$E(n.we, 'role', 'dialog'), $4c08ceecfc768f1b$var$E(n.we, $4c08ceecfc768f1b$var$i, !0), $4c08ceecfc768f1b$var$E(n.we, 'aria-modal', !0), $4c08ceecfc768f1b$var$E(n.we, 'aria-labelledby', 'pm__title'), $4c08ceecfc768f1b$var$R(n.ye, 'keydown', (e)=>{
            27 === e.keyCode && s();
        }, !0), n.Oe = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$L(n.Oe, 'header'), n.Re = $4c08ceecfc768f1b$var$k('h2'), $4c08ceecfc768f1b$var$L(n.Re, 'title'), n.Re.id = 'pm__title', n.Be = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$L(n.Be, 'close-btn'), $4c08ceecfc768f1b$var$E(n.Be, 'aria-label', m.closeIconLabel || ''), $4c08ceecfc768f1b$var$R(n.Be, $4c08ceecfc768f1b$var$d, s), n.$e = $4c08ceecfc768f1b$var$k('span'), n.$e.innerHTML = $4c08ceecfc768f1b$var$W(), $4c08ceecfc768f1b$var$H(n.Be, n.$e), n.Ge = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$L(n.Ge, 'body'), n.Je = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$L(n.Je, 'footer');
        var T = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
        $4c08ceecfc768f1b$var$V(T, 'btns');
        var A = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), N = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
        $4c08ceecfc768f1b$var$L(A, $4c08ceecfc768f1b$var$l), $4c08ceecfc768f1b$var$L(N, $4c08ceecfc768f1b$var$l), $4c08ceecfc768f1b$var$H(n.Je, A), $4c08ceecfc768f1b$var$H(n.Je, N), $4c08ceecfc768f1b$var$H(n.Oe, n.Re), $4c08ceecfc768f1b$var$H(n.Oe, n.Be), n.ve = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$E(n.ve, 'tabIndex', -1), $4c08ceecfc768f1b$var$H(n.we, n.ve), $4c08ceecfc768f1b$var$H(n.we, n.Oe), $4c08ceecfc768f1b$var$H(n.we, n.Ge), D && $4c08ceecfc768f1b$var$H(n.we, n.Je), $4c08ceecfc768f1b$var$H(n.Fe, n.we);
    }
    let I;
    b && (n.Re.innerHTML = b, v && $4c08ceecfc768f1b$var$E(n.Be, 'aria-label', v)), M.forEach((e, t)=>{
        const a = e.title, s = e.description, l = e.linkedCategory, f = l && o.P[l], _ = e.cookieTable, u = _ && _.body, p = _ && _.caption, g = u && u.length > 0, b = !!f, v = b && o.X[l], C = $4c08ceecfc768f1b$var$h(v) && $4c08ceecfc768f1b$var$w(v) || [], S = b && (!!s || !!g || $4c08ceecfc768f1b$var$w(v).length > 0);
        var x = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
        if ($4c08ceecfc768f1b$var$L(x, 'section'), S || s) {
            var M = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
            $4c08ceecfc768f1b$var$L(M, 'section-desc-wrapper');
        }
        let D = C.length;
        if (S && D > 0) {
            const e = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
            $4c08ceecfc768f1b$var$L(e, 'section-services');
            for (const t of C){
                const o = v[t], n = o && o.label || t, a = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), s = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), r = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), i = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
                $4c08ceecfc768f1b$var$L(a, 'service'), $4c08ceecfc768f1b$var$L(i, 'service-title'), $4c08ceecfc768f1b$var$L(s, 'service-header'), $4c08ceecfc768f1b$var$L(r, 'service-icon');
                const d = $4c08ceecfc768f1b$var$be(n, t, f, !0, l);
                i.innerHTML = n, $4c08ceecfc768f1b$var$H(s, r), $4c08ceecfc768f1b$var$H(s, i), $4c08ceecfc768f1b$var$H(a, s), $4c08ceecfc768f1b$var$H(a, d), $4c08ceecfc768f1b$var$H(e, a);
            }
            $4c08ceecfc768f1b$var$H(M, e);
        }
        if (a) {
            var T = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), A = $4c08ceecfc768f1b$var$k(b ? $4c08ceecfc768f1b$var$r : $4c08ceecfc768f1b$var$c);
            if ($4c08ceecfc768f1b$var$L(T, 'section-title-wrapper'), $4c08ceecfc768f1b$var$L(A, 'section-title'), A.innerHTML = a, $4c08ceecfc768f1b$var$H(T, A), b) {
                const e = $4c08ceecfc768f1b$var$k('span');
                e.innerHTML = $4c08ceecfc768f1b$var$W(2, 3.5), $4c08ceecfc768f1b$var$L(e, 'section-arrow'), $4c08ceecfc768f1b$var$H(T, e), x.className += '--toggle';
                const t = $4c08ceecfc768f1b$var$be(a, l, f);
                let o = m.serviceCounterLabel;
                if (D > 0 && $4c08ceecfc768f1b$var$y(o)) {
                    let e = $4c08ceecfc768f1b$var$k('span');
                    $4c08ceecfc768f1b$var$L(e, 'badge'), $4c08ceecfc768f1b$var$L(e, 'service-counter'), $4c08ceecfc768f1b$var$E(e, $4c08ceecfc768f1b$var$i, !0), $4c08ceecfc768f1b$var$E(e, 'data-servicecounter', D), o && (o = o.split('|'), o = o.length > 1 && D > 1 ? o[1] : o[0], $4c08ceecfc768f1b$var$E(e, 'data-counterlabel', o)), e.innerHTML = D + (o ? ' ' + o : ''), $4c08ceecfc768f1b$var$H(A, e);
                }
                if (S) {
                    $4c08ceecfc768f1b$var$L(x, 'section--expandable');
                    var N = l + '-desc';
                    $4c08ceecfc768f1b$var$E(A, 'aria-expanded', !1), $4c08ceecfc768f1b$var$E(A, 'aria-controls', N);
                }
                $4c08ceecfc768f1b$var$H(T, t);
            } else $4c08ceecfc768f1b$var$E(A, 'role', 'heading'), $4c08ceecfc768f1b$var$E(A, 'aria-level', '3');
            $4c08ceecfc768f1b$var$H(x, T);
        }
        if (s) {
            var F = $4c08ceecfc768f1b$var$k('p');
            $4c08ceecfc768f1b$var$L(F, 'section-desc'), F.innerHTML = s, $4c08ceecfc768f1b$var$H(M, F);
        }
        if (S && ($4c08ceecfc768f1b$var$E(M, $4c08ceecfc768f1b$var$i, 'true'), M.id = N, ((e, t, o)=>{
            $4c08ceecfc768f1b$var$R(A, $4c08ceecfc768f1b$var$d, ()=>{
                t.classList.contains('is-expanded') ? ($4c08ceecfc768f1b$var$j(t, 'is-expanded'), $4c08ceecfc768f1b$var$E(o, 'aria-expanded', 'false'), $4c08ceecfc768f1b$var$E(e, $4c08ceecfc768f1b$var$i, 'true')) : ($4c08ceecfc768f1b$var$V(t, 'is-expanded'), $4c08ceecfc768f1b$var$E(o, 'aria-expanded', 'true'), $4c08ceecfc768f1b$var$E(e, $4c08ceecfc768f1b$var$i, 'false'));
            });
        })(M, x, A), g)) {
            const e = $4c08ceecfc768f1b$var$k('table'), o = $4c08ceecfc768f1b$var$k('thead'), a = $4c08ceecfc768f1b$var$k('tbody');
            if (p) {
                const t = $4c08ceecfc768f1b$var$k('caption');
                $4c08ceecfc768f1b$var$L(t, 'table-caption'), t.innerHTML = p, e.appendChild(t);
            }
            $4c08ceecfc768f1b$var$L(e, 'section-table'), $4c08ceecfc768f1b$var$L(o, 'table-head'), $4c08ceecfc768f1b$var$L(a, 'table-body');
            const s = _.headers, r = $4c08ceecfc768f1b$var$w(s), i = n.Ue.createDocumentFragment(), l = $4c08ceecfc768f1b$var$k('tr');
            for (const e of r){
                const o = s[e], n = $4c08ceecfc768f1b$var$k('th');
                n.id = 'cc__row-' + o + t, $4c08ceecfc768f1b$var$E(n, 'scope', 'col'), $4c08ceecfc768f1b$var$L(n, 'table-th'), n.innerHTML = o, $4c08ceecfc768f1b$var$H(i, n);
            }
            $4c08ceecfc768f1b$var$H(l, i), $4c08ceecfc768f1b$var$H(o, l);
            const d = n.Ue.createDocumentFragment();
            for (const e of u){
                const o = $4c08ceecfc768f1b$var$k('tr');
                $4c08ceecfc768f1b$var$L(o, 'table-tr');
                for (const n of r){
                    const a = s[n], r = e[n], i = $4c08ceecfc768f1b$var$k('td'), l = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
                    $4c08ceecfc768f1b$var$L(i, 'table-td'), $4c08ceecfc768f1b$var$E(i, 'data-column', a), $4c08ceecfc768f1b$var$E(i, 'headers', 'cc__row-' + a + t), l.insertAdjacentHTML('beforeend', r), $4c08ceecfc768f1b$var$H(i, l), $4c08ceecfc768f1b$var$H(o, i);
                }
                $4c08ceecfc768f1b$var$H(d, o);
            }
            $4c08ceecfc768f1b$var$H(a, d), $4c08ceecfc768f1b$var$H(e, o), $4c08ceecfc768f1b$var$H(e, a), $4c08ceecfc768f1b$var$H(M, e);
        }
        (S || s) && $4c08ceecfc768f1b$var$H(x, M);
        const P = n.Pe || n.Ge;
        b ? (I || (I = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$L(I, 'section-toggles')), I.appendChild(x)) : I = null, $4c08ceecfc768f1b$var$H(P, I || x);
    }), C && (n.ze || (n.ze = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$L(n.ze, 'btn'), $4c08ceecfc768f1b$var$E(n.ze, $4c08ceecfc768f1b$var$f, 'all'), $4c08ceecfc768f1b$var$H(A, n.ze), $4c08ceecfc768f1b$var$R(n.ze, $4c08ceecfc768f1b$var$d, ()=>p('all'))), n.ze.innerHTML = C), S && (n.je || (n.je = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$L(n.je, 'btn'), $4c08ceecfc768f1b$var$E(n.je, $4c08ceecfc768f1b$var$f, 'necessary'), $4c08ceecfc768f1b$var$H(A, n.je), $4c08ceecfc768f1b$var$R(n.je, $4c08ceecfc768f1b$var$d, ()=>p([]))), n.je.innerHTML = S), x && (n.qe || (n.qe = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$L(n.qe, 'btn'), $4c08ceecfc768f1b$var$L(n.qe, 'btn--secondary'), $4c08ceecfc768f1b$var$E(n.qe, $4c08ceecfc768f1b$var$f, 'save'), $4c08ceecfc768f1b$var$H(N, n.qe), $4c08ceecfc768f1b$var$R(n.qe, $4c08ceecfc768f1b$var$d, ()=>p())), n.qe.innerHTML = x), n.Pe && (n.we.replaceChild(n.Pe, n.Ge), n.Ge = n.Pe), $4c08ceecfc768f1b$var$pe(1), o.N || (o.N = !0, $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.ue, $4c08ceecfc768f1b$var$u, n.we), t(e), $4c08ceecfc768f1b$var$H(n.Ce, n.Fe), $4c08ceecfc768f1b$var$X(n.we), setTimeout(()=>$4c08ceecfc768f1b$var$V(n.Fe, 'cc--anim'), 100)), $4c08ceecfc768f1b$var$Z(2);
};
function $4c08ceecfc768f1b$var$be(e, t, o, n, a) {
    const c = $4c08ceecfc768f1b$var$g.o, r = $4c08ceecfc768f1b$var$g.ne, l = $4c08ceecfc768f1b$var$k('label'), f = $4c08ceecfc768f1b$var$k('input'), _ = $4c08ceecfc768f1b$var$k('span'), u = $4c08ceecfc768f1b$var$k('span'), p = $4c08ceecfc768f1b$var$k('span'), m = $4c08ceecfc768f1b$var$k('span'), v = $4c08ceecfc768f1b$var$k('span');
    if (m.innerHTML = $4c08ceecfc768f1b$var$W(1, 3), v.innerHTML = $4c08ceecfc768f1b$var$W(0, 3), f.type = 'checkbox', $4c08ceecfc768f1b$var$V(l, 'section__toggle-wrapper'), $4c08ceecfc768f1b$var$V(f, 'section__toggle'), $4c08ceecfc768f1b$var$V(m, 'toggle__icon-on'), $4c08ceecfc768f1b$var$V(v, 'toggle__icon-off'), $4c08ceecfc768f1b$var$V(_, 'toggle__icon'), $4c08ceecfc768f1b$var$V(u, 'toggle__icon-circle'), $4c08ceecfc768f1b$var$V(p, 'toggle__label'), $4c08ceecfc768f1b$var$E(_, $4c08ceecfc768f1b$var$i, 'true'), n ? ($4c08ceecfc768f1b$var$V(l, 'toggle-service'), $4c08ceecfc768f1b$var$E(f, $4c08ceecfc768f1b$var$s, a), r.se[a][t] = f) : r.ae[t] = f, n ? ((e)=>{
        $4c08ceecfc768f1b$var$R(f, 'change', ()=>{
            const t = r.se[e], o = r.ae[e];
            c.Z[e] = [];
            for(let o in t){
                const n = t[o];
                n.checked && c.Z[e].push(n.value);
            }
            o.checked = c.Z[e].length > 0;
        });
    })(a) : ((e)=>{
        $4c08ceecfc768f1b$var$R(f, $4c08ceecfc768f1b$var$d, ()=>{
            const t = r.se[e], o = f.checked;
            c.Z[e] = [];
            for(let n in t)t[n].checked = o, o && c.Z[e].push(n);
        });
    })(t), f.value = t, p.textContent = e.replace(/<.*>.*<\/.*>/gm, ''), $4c08ceecfc768f1b$var$H(u, v), $4c08ceecfc768f1b$var$H(u, m), $4c08ceecfc768f1b$var$H(_, u), c.D) (o.readOnly || o.enabled) && (f.checked = !0);
    else if (n) {
        const e = c.Y[a];
        f.checked = o.readOnly || $4c08ceecfc768f1b$var$b(e, t);
    } else $4c08ceecfc768f1b$var$b(c.R, t) && (f.checked = !0);
    return o.readOnly && (f.disabled = !0), $4c08ceecfc768f1b$var$H(l, f), $4c08ceecfc768f1b$var$H(l, _), $4c08ceecfc768f1b$var$H(l, p), l;
}
const $4c08ceecfc768f1b$var$ve = ()=>{
    const e = $4c08ceecfc768f1b$var$k('span');
    return $4c08ceecfc768f1b$var$g.ne.Ke || ($4c08ceecfc768f1b$var$g.ne.Ke = e), e;
}, $4c08ceecfc768f1b$var$ye = (e, t)=>{
    const o = $4c08ceecfc768f1b$var$g.o, n = $4c08ceecfc768f1b$var$g.ne, { hide: a, showPreferences: s, acceptCategory: u } = e, p = o.u && o.u.consentModal;
    if (!p) return;
    const m = p.acceptAllBtn, b = p.acceptNecessaryBtn, v = p.showPreferencesBtn, y = p.closeIconLabel, h = p.footer, C = p.label, w = p.title, S = (e)=>{
        a(), u(e);
    };
    if (!n.Qe) {
        n.Qe = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), n.he = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), n.We = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), n.Xe = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), n.Ye = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$V(n.Qe, 'cm-wrapper'), $4c08ceecfc768f1b$var$V(n.he, 'cm'), $4c08ceecfc768f1b$var$I(n.We, 'body'), $4c08ceecfc768f1b$var$I(n.Xe, 'texts'), $4c08ceecfc768f1b$var$I(n.Ye, 'btns'), $4c08ceecfc768f1b$var$E(n.he, 'role', 'dialog'), $4c08ceecfc768f1b$var$E(n.he, 'aria-modal', 'true'), $4c08ceecfc768f1b$var$E(n.he, $4c08ceecfc768f1b$var$i, 'false'), $4c08ceecfc768f1b$var$E(n.he, 'aria-describedby', 'cm__desc'), C ? $4c08ceecfc768f1b$var$E(n.he, 'aria-label', C) : w && $4c08ceecfc768f1b$var$E(n.he, 'aria-labelledby', 'cm__title');
        const e = 'box', t = o.i.guiOptions, a = t && t.consentModal, s = (a && a.layout || e).split(' ')[0] === e;
        w && y && s && (n.Le || (n.Le = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), n.Le.innerHTML = $4c08ceecfc768f1b$var$W(), $4c08ceecfc768f1b$var$I(n.Le, 'btn'), $4c08ceecfc768f1b$var$I(n.Le, 'btn--close'), $4c08ceecfc768f1b$var$R(n.Le, $4c08ceecfc768f1b$var$d, ()=>{
            S([]);
        }), $4c08ceecfc768f1b$var$H(n.We, n.Le)), $4c08ceecfc768f1b$var$E(n.Le, 'aria-label', y)), $4c08ceecfc768f1b$var$H(n.We, n.Xe), (m || b || v) && $4c08ceecfc768f1b$var$H(n.We, n.Ye), n.be = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$E(n.be, 'tabIndex', -1), $4c08ceecfc768f1b$var$H(n.he, n.be), $4c08ceecfc768f1b$var$H(n.he, n.We), $4c08ceecfc768f1b$var$H(n.Qe, n.he);
    }
    w && (n.Ze || (n.Ze = $4c08ceecfc768f1b$var$k('h2'), n.Ze.className = n.Ze.id = 'cm__title', $4c08ceecfc768f1b$var$H(n.Xe, n.Ze)), n.Ze.innerHTML = w);
    let x = p.description;
    if (x && (o.V && (x = x.replace('{{revisionMessage}}', o.I ? '' : p.revisionMessage || '')), n.et || (n.et = $4c08ceecfc768f1b$var$k('p'), n.et.className = n.et.id = 'cm__desc', $4c08ceecfc768f1b$var$H(n.Xe, n.et)), n.et.innerHTML = x), m && (n.tt || (n.tt = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$H(n.tt, $4c08ceecfc768f1b$var$ve()), $4c08ceecfc768f1b$var$I(n.tt, 'btn'), $4c08ceecfc768f1b$var$E(n.tt, $4c08ceecfc768f1b$var$f, 'all'), $4c08ceecfc768f1b$var$R(n.tt, $4c08ceecfc768f1b$var$d, ()=>{
        S('all');
    })), n.tt.firstElementChild.innerHTML = m), b && (n.Ie || (n.Ie = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$H(n.Ie, $4c08ceecfc768f1b$var$ve()), $4c08ceecfc768f1b$var$I(n.Ie, 'btn'), $4c08ceecfc768f1b$var$E(n.Ie, $4c08ceecfc768f1b$var$f, 'necessary'), $4c08ceecfc768f1b$var$R(n.Ie, $4c08ceecfc768f1b$var$d, ()=>{
        S([]);
    })), n.Ie.firstElementChild.innerHTML = b), v && (n.ot || (n.ot = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$r), $4c08ceecfc768f1b$var$H(n.ot, $4c08ceecfc768f1b$var$ve()), $4c08ceecfc768f1b$var$I(n.ot, 'btn'), $4c08ceecfc768f1b$var$I(n.ot, 'btn--secondary'), $4c08ceecfc768f1b$var$E(n.ot, $4c08ceecfc768f1b$var$f, 'show'), $4c08ceecfc768f1b$var$R(n.ot, 'mouseenter', ()=>{
        o.N || $4c08ceecfc768f1b$var$me(e, t);
    }), $4c08ceecfc768f1b$var$R(n.ot, $4c08ceecfc768f1b$var$d, s)), n.ot.firstElementChild.innerHTML = v), n.nt || (n.nt = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$I(n.nt, $4c08ceecfc768f1b$var$l), m && $4c08ceecfc768f1b$var$H(n.nt, n.tt), b && $4c08ceecfc768f1b$var$H(n.nt, n.Ie), (m || b) && $4c08ceecfc768f1b$var$H(n.We, n.nt), $4c08ceecfc768f1b$var$H(n.Ye, n.nt)), n.ot && !n.st && (n.st = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), n.Ie && n.tt ? ($4c08ceecfc768f1b$var$I(n.st, $4c08ceecfc768f1b$var$l), $4c08ceecfc768f1b$var$H(n.st, n.ot), $4c08ceecfc768f1b$var$H(n.Ye, n.st)) : ($4c08ceecfc768f1b$var$H(n.nt, n.ot), $4c08ceecfc768f1b$var$I(n.nt, $4c08ceecfc768f1b$var$l + '--uneven'))), h) {
        if (!n.ct) {
            let e = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), t = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c);
            n.ct = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), $4c08ceecfc768f1b$var$I(e, 'footer'), $4c08ceecfc768f1b$var$I(t, 'links'), $4c08ceecfc768f1b$var$I(n.ct, 'link-group'), $4c08ceecfc768f1b$var$H(t, n.ct), $4c08ceecfc768f1b$var$H(e, t), $4c08ceecfc768f1b$var$H(n.he, e);
        }
        n.ct.innerHTML = h;
    }
    $4c08ceecfc768f1b$var$pe(0), o.T || (o.T = !0, $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.ue, $4c08ceecfc768f1b$var$_, n.he), t(e), $4c08ceecfc768f1b$var$H(n.Ce, n.Qe), $4c08ceecfc768f1b$var$X(n.he), setTimeout(()=>$4c08ceecfc768f1b$var$V(n.Qe, 'cc--anim'), 100)), $4c08ceecfc768f1b$var$Z(1), $4c08ceecfc768f1b$var$J(n.We, e, $4c08ceecfc768f1b$var$me, t);
}, $4c08ceecfc768f1b$var$he = (e)=>{
    if (!$4c08ceecfc768f1b$var$y(e)) return null;
    if (e in $4c08ceecfc768f1b$var$g.o._) return e;
    let t = e.slice(0, 2);
    return t in $4c08ceecfc768f1b$var$g.o._ ? t : null;
}, $4c08ceecfc768f1b$var$Ce = ()=>$4c08ceecfc768f1b$var$g.o.l || $4c08ceecfc768f1b$var$g.o.i.language.default, $4c08ceecfc768f1b$var$we = (e)=>{
    e && ($4c08ceecfc768f1b$var$g.o.l = e);
}, $4c08ceecfc768f1b$var$Se = async (e)=>{
    const t = $4c08ceecfc768f1b$var$g.o;
    let o = $4c08ceecfc768f1b$var$he(e) ? e : $4c08ceecfc768f1b$var$Ce(), n = t._[o];
    if ($4c08ceecfc768f1b$var$y(n) ? n = await (async (e)=>{
        try {
            const t = await fetch(e);
            return await t.json();
        } catch (e) {
            return console.error(e), !1;
        }
    })(n) : $4c08ceecfc768f1b$var$C(n) && (n = await n()), !n) throw `Could not load translation for the '${o}' language`;
    return t.u = n, $4c08ceecfc768f1b$var$we(o), !0;
}, $4c08ceecfc768f1b$var$xe = ()=>{
    let e = $4c08ceecfc768f1b$var$g.o.i.language.rtl, t = $4c08ceecfc768f1b$var$g.ne.Ce;
    e && t && ($4c08ceecfc768f1b$var$v(e) || (e = [
        e
    ]), $4c08ceecfc768f1b$var$b(e, $4c08ceecfc768f1b$var$g.o.l) ? $4c08ceecfc768f1b$var$V(t, 'cc--rtl') : $4c08ceecfc768f1b$var$j(t, 'cc--rtl'));
}, $4c08ceecfc768f1b$var$Me = ()=>{
    const e = $4c08ceecfc768f1b$var$g.ne;
    if (e.Ce) return;
    e.Ce = $4c08ceecfc768f1b$var$k($4c08ceecfc768f1b$var$c), e.Ce.id = 'cc-main', e.Ce.setAttribute('data-nosnippet', ''), $4c08ceecfc768f1b$var$xe();
    let t = $4c08ceecfc768f1b$var$g.o.i.root;
    t && $4c08ceecfc768f1b$var$y(t) && (t = document.querySelector(t)), (t || e.Ue.body).appendChild(e.Ce);
}, $4c08ceecfc768f1b$var$De = (e)=>$4c08ceecfc768f1b$var$te(()=>localStorage.removeItem(e)), $4c08ceecfc768f1b$var$Te = (e, t)=>{
    if (t instanceof RegExp) return e.filter((e)=>t.test(e));
    {
        const o = $4c08ceecfc768f1b$var$m(e, t);
        return o > -1 ? [
            e[o]
        ] : [];
    }
}, $4c08ceecfc768f1b$var$ke = (e)=>{
    const { hostname: t, protocol: o } = location, { name: n, path: a, domain: s, sameSite: c, useLocalStorage: r, secure: i } = $4c08ceecfc768f1b$var$g.t.cookie, l = e ? (()=>{
        const e = $4c08ceecfc768f1b$var$g.o.S, t = e ? new Date - e : 0;
        return 864e5 * $4c08ceecfc768f1b$var$B() - t;
    })() : 864e5 * $4c08ceecfc768f1b$var$B(), d = new Date;
    d.setTime(d.getTime() + l), $4c08ceecfc768f1b$var$g.o.p.expirationTime = d.getTime();
    const f = JSON.stringify($4c08ceecfc768f1b$var$g.o.p);
    let _ = n + '=' + encodeURIComponent(f) + (0 !== l ? '; expires=' + d.toUTCString() : '') + '; Path=' + a + '; SameSite=' + c;
    $4c08ceecfc768f1b$var$b(t, '.') && (_ += '; Domain=' + s), i && 'https:' === o && (_ += '; Secure'), r ? ((e, t)=>{
        $4c08ceecfc768f1b$var$te(()=>localStorage.setItem(e, t));
    })(n, f) : document.cookie = _, $4c08ceecfc768f1b$var$g.o.p;
}, $4c08ceecfc768f1b$var$Ee = (e, t, o)=>{
    if (0 === e.length) return;
    const n = o || $4c08ceecfc768f1b$var$g.t.cookie.domain, a = t || $4c08ceecfc768f1b$var$g.t.cookie.path, s = 'www.' === n.slice(0, 4), c = s && n.substring(4), r = (e, t)=>{
        t && '.' !== t.slice(0, 1) && (t = '.' + t), document.cookie = e + '=; path=' + a + (t ? '; domain=' + t : '') + '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };
    for (const t of e)r(t, o), o || r(t, n), s && r(t, c);
}, $4c08ceecfc768f1b$var$Ae = (e)=>{
    const t = e || $4c08ceecfc768f1b$var$g.t.cookie.name, o = $4c08ceecfc768f1b$var$g.t.cookie.useLocalStorage;
    var n;
    return ((e, t)=>{
        let o;
        return o = $4c08ceecfc768f1b$var$te(()=>JSON.parse(t ? e : decodeURIComponent(e)), !0) || {}, o;
    })(o ? (n = t, $4c08ceecfc768f1b$var$te(()=>localStorage.getItem(n)) || '') : $4c08ceecfc768f1b$var$Ne(t, !0), o);
}, $4c08ceecfc768f1b$var$Ne = (e, t)=>{
    const o = document.cookie.match('(^|;)\\s*' + e + '\\s*=\\s*([^;]+)');
    return o ? t ? o.pop() : e : '';
}, $4c08ceecfc768f1b$var$He = (e)=>{
    const t = document.cookie.split(/;\s*/), o = [];
    for (const n of t){
        let t = n.split('=')[0];
        e ? $4c08ceecfc768f1b$var$te(()=>{
            e.test(t) && o.push(t);
        }) : o.push(t);
    }
    return o;
}, $4c08ceecfc768f1b$export$f733614a75aede52 = (o, n = [])=>{
    ((e, t)=>{
        const { O: o, R: n, B: a, N: s, Z: c, $: r, X: i } = $4c08ceecfc768f1b$var$g.o;
        let l = [];
        if (e) {
            $4c08ceecfc768f1b$var$v(e) ? l.push(...e) : $4c08ceecfc768f1b$var$y(e) && (l = 'all' === e ? o : [
                e
            ]);
            for (const e of o)c[e] = $4c08ceecfc768f1b$var$b(l, e) ? $4c08ceecfc768f1b$var$w(i[e]) : [];
        } else l = [
            ...n,
            ...r
        ], s && (l = (()=>{
            const e = $4c08ceecfc768f1b$var$g.ne.ae;
            if (!e) return [];
            let t = [];
            for(let o in e)e[o].checked && t.push(o);
            return t;
        })());
        l = l.filter((e)=>!$4c08ceecfc768f1b$var$b(o, e) || !$4c08ceecfc768f1b$var$b(t, e)), l.push(...a), $4c08ceecfc768f1b$var$G(l);
    })(o, n), (()=>{
        const e = $4c08ceecfc768f1b$var$g.o, { Z: t, B: o, Y: n, X: a, O: s } = e, c = s;
        e.te = $4c08ceecfc768f1b$var$F(n);
        for (const s of c){
            const c = a[s], r = $4c08ceecfc768f1b$var$w(c), i = t[s] && t[s].length > 0, l = $4c08ceecfc768f1b$var$b(o, s);
            if (0 !== r.length) {
                if (n[s] = [], l) n[s].push(...r);
                else if (i) {
                    const e = t[s];
                    n[s].push(...e);
                } else n[s] = e.Z[s];
                n[s] = $4c08ceecfc768f1b$var$S(n[s]);
            }
        }
    })(), (()=>{
        const o = $4c08ceecfc768f1b$var$g.o;
        o.L = $4c08ceecfc768f1b$var$g.t.mode === $4c08ceecfc768f1b$var$t && o.D ? $4c08ceecfc768f1b$var$$(o.$, o.R) : $4c08ceecfc768f1b$var$$(o.R, o.p.categories);
        let n = o.L.length > 0, a = !1;
        for (const e of o.O)o.ee[e] = $4c08ceecfc768f1b$var$$(o.Y[e], o.te[e]), o.ee[e].length > 0 && (a = !0);
        const s = $4c08ceecfc768f1b$var$g.ne.ae;
        for(const e in s)s[e].checked = $4c08ceecfc768f1b$var$b(o.R, e);
        for (const e of o.O){
            const t = $4c08ceecfc768f1b$var$g.ne.se[e], n = o.Y[e];
            for(const e in t)t[e].checked = $4c08ceecfc768f1b$var$b(n, e);
        }
        o.C || (o.C = new Date), o.M || (o.M = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e)=>(e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16))), o.p = {
            categories: $4c08ceecfc768f1b$var$F(o.R),
            revision: $4c08ceecfc768f1b$var$g.t.revision,
            data: o.h,
            consentTimestamp: o.C.toISOString(),
            consentId: o.M,
            services: $4c08ceecfc768f1b$var$F(o.Y),
            languageCode: $4c08ceecfc768f1b$var$g.o.l
        }, o.S && (o.p.lastConsentTimestamp = o.S.toISOString());
        let c = !1;
        const r = n || a;
        (o.D || r) && (o.D && (o.D = !1, c = !0), o.S = o.S ? new Date : o.C, o.p.lastConsentTimestamp = o.S.toISOString(), $4c08ceecfc768f1b$var$ke(), $4c08ceecfc768f1b$var$g.t.autoClearCookies && (c || r) && ((e)=>{
            const t = $4c08ceecfc768f1b$var$g.o, o = $4c08ceecfc768f1b$var$He(), n = ((e)=>{
                const t = $4c08ceecfc768f1b$var$g.o;
                return (e ? t.O : t.L).filter((e)=>{
                    const o = t.P[e];
                    return !!o && !o.readOnly && !!o.autoClear;
                });
            })(e);
            for(const e in t.ee)for (const n of t.ee[e]){
                const a = t.X[e][n].cookies;
                if (!$4c08ceecfc768f1b$var$b(t.Y[e], n) && a) for (const e of a){
                    const t = $4c08ceecfc768f1b$var$Te(o, e.name);
                    $4c08ceecfc768f1b$var$Ee(t, e.path, e.domain);
                }
            }
            for (const a of n){
                const n = t.P[a].autoClear, s = n && n.cookies || [], c = $4c08ceecfc768f1b$var$b(t.L, a), r = !$4c08ceecfc768f1b$var$b(t.R, a), i = c && r;
                if (e ? r : i) {
                    n.reloadPage && i && (t.j = !0);
                    for (const e of s){
                        const t = $4c08ceecfc768f1b$var$Te(o, e.name);
                        $4c08ceecfc768f1b$var$Ee(t, e.path, e.domain);
                    }
                }
            }
        })(c), $4c08ceecfc768f1b$var$oe()), c && ($4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.ie), $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.le), $4c08ceecfc768f1b$var$g.t.mode === $4c08ceecfc768f1b$var$e) || (r && $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.de), o.j && (o.j = !1, location.reload()));
    })();
}, $4c08ceecfc768f1b$export$d57953daf19d40f0 = (e)=>{
    const t = $4c08ceecfc768f1b$var$g.o.D ? [] : $4c08ceecfc768f1b$var$g.o.R;
    return $4c08ceecfc768f1b$var$b(t, e);
}, $4c08ceecfc768f1b$export$954bc960519baaed = (e, t)=>{
    const { O: o, X: n } = $4c08ceecfc768f1b$var$g.o;
    if (!(e && t && $4c08ceecfc768f1b$var$y(t) && $4c08ceecfc768f1b$var$b(o, t) && 0 !== $4c08ceecfc768f1b$var$w(n[t]).length)) return !1;
    ((e, t)=>{
        const o = $4c08ceecfc768f1b$var$g.o, { X: n, Z: a, N: s } = o, c = $4c08ceecfc768f1b$var$g.ne.se[t] || {}, r = $4c08ceecfc768f1b$var$g.ne.ae[t] || {}, i = $4c08ceecfc768f1b$var$w(n[t]);
        if (a[t] = [], $4c08ceecfc768f1b$var$y(e)) {
            if ('all' === e) {
                if (a[t].push(...i), s) for(let e in c)c[e].checked = !0, $4c08ceecfc768f1b$var$T(c[e]);
            } else if ($4c08ceecfc768f1b$var$b(i, e) && a[t].push(e), s) for(let t in c)c[t].checked = e === t, $4c08ceecfc768f1b$var$T(c[t]);
        } else if ($4c08ceecfc768f1b$var$v(e)) for (let o of i){
            const n = $4c08ceecfc768f1b$var$b(e, o);
            n && a[t].push(o), s && (c[o].checked = n, $4c08ceecfc768f1b$var$T(c[o]));
        }
        const l = 0 === a[t].length;
        o.R = l ? o.R.filter((e)=>e !== t) : $4c08ceecfc768f1b$var$S([
            ...o.R,
            t
        ]), s && (r.checked = !l, $4c08ceecfc768f1b$var$T(r));
    })(e, t), $4c08ceecfc768f1b$export$f733614a75aede52();
}, $4c08ceecfc768f1b$export$c6d040ca60661d88 = (e, t)=>{
    const o = $4c08ceecfc768f1b$var$g.o.D ? [] : $4c08ceecfc768f1b$var$g.o.Y[t] || [];
    return $4c08ceecfc768f1b$var$b(o, e);
}, $4c08ceecfc768f1b$export$26b2c20fc8da53a0 = (e)=>'' !== $4c08ceecfc768f1b$var$Ne(e, !0), $4c08ceecfc768f1b$export$6dde6a4e31d2b3a6 = (e, t, o)=>{
    let n = [];
    const a = (e)=>{
        if ($4c08ceecfc768f1b$var$y(e)) {
            let t = $4c08ceecfc768f1b$var$Ne(e);
            '' !== t && n.push(t);
        } else n.push(...$4c08ceecfc768f1b$var$He(e));
    };
    if ($4c08ceecfc768f1b$var$v(e)) for (let t of e)a(t);
    else a(e);
    $4c08ceecfc768f1b$var$Ee(n, t, o);
}, $4c08ceecfc768f1b$export$57bf213be019eeb0 = (e)=>{
    const { ne: t, o: n } = $4c08ceecfc768f1b$var$g;
    if (!n.k) {
        if (!n.T) {
            if (!e) return;
            $4c08ceecfc768f1b$var$ye($4c08ceecfc768f1b$var$Ge, $4c08ceecfc768f1b$var$Me);
        }
        n.k = !0, n.J = $4c08ceecfc768f1b$var$x(), n.v && $4c08ceecfc768f1b$var$K(!0), $4c08ceecfc768f1b$var$z(t.he, 1), $4c08ceecfc768f1b$var$V(t.ye, $4c08ceecfc768f1b$var$o), $4c08ceecfc768f1b$var$E(t.he, $4c08ceecfc768f1b$var$i, 'false'), setTimeout(()=>{
            $4c08ceecfc768f1b$var$U($4c08ceecfc768f1b$var$g.ne.be);
        }, 100), $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.fe, $4c08ceecfc768f1b$var$_);
    }
}, $4c08ceecfc768f1b$export$fe8985bb6374093c = ()=>{
    const { ne: e, o: t, re: n } = $4c08ceecfc768f1b$var$g;
    t.k && (t.k = !1, t.v && $4c08ceecfc768f1b$var$K(), $4c08ceecfc768f1b$var$U(e.Ke, !0), $4c08ceecfc768f1b$var$j(e.ye, $4c08ceecfc768f1b$var$o), $4c08ceecfc768f1b$var$E(e.he, $4c08ceecfc768f1b$var$i, 'true'), $4c08ceecfc768f1b$var$U(t.J), t.J = null, $4c08ceecfc768f1b$var$ee(n._e, $4c08ceecfc768f1b$var$_));
}, $4c08ceecfc768f1b$export$535e69674d40eb20 = ()=>{
    const e = $4c08ceecfc768f1b$var$g.o;
    e.A || (e.N || $4c08ceecfc768f1b$var$me($4c08ceecfc768f1b$var$Ge, $4c08ceecfc768f1b$var$Me), e.A = !0, e.k ? e.U = $4c08ceecfc768f1b$var$x() : e.J = $4c08ceecfc768f1b$var$x(), $4c08ceecfc768f1b$var$z($4c08ceecfc768f1b$var$g.ne.we, 2), $4c08ceecfc768f1b$var$V($4c08ceecfc768f1b$var$g.ne.ye, $4c08ceecfc768f1b$var$n), $4c08ceecfc768f1b$var$E($4c08ceecfc768f1b$var$g.ne.we, $4c08ceecfc768f1b$var$i, 'false'), setTimeout(()=>{
        $4c08ceecfc768f1b$var$U($4c08ceecfc768f1b$var$g.ne.ve);
    }, 100), $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re.fe, $4c08ceecfc768f1b$var$u));
}, $4c08ceecfc768f1b$export$5b3a895f6cbac580 = ()=>{
    const e = $4c08ceecfc768f1b$var$g.o;
    e.A && (e.A = !1, (()=>{
        const e = $4c08ceecfc768f1b$export$3bdcc4c9b3764a39(), t = $4c08ceecfc768f1b$var$g.o.P, o = $4c08ceecfc768f1b$var$g.ne.ae, n = $4c08ceecfc768f1b$var$g.ne.se, a = (e)=>$4c08ceecfc768f1b$var$b($4c08ceecfc768f1b$var$g.o.$, e);
        for(const s in o){
            const c = !!t[s].readOnly;
            o[s].checked = c || (e ? $4c08ceecfc768f1b$export$d57953daf19d40f0(s) : a(s));
            for(const t in n[s])n[s][t].checked = c || (e ? $4c08ceecfc768f1b$export$c6d040ca60661d88(t, s) : a(s));
        }
    })(), $4c08ceecfc768f1b$var$U($4c08ceecfc768f1b$var$g.ne.$e, !0), $4c08ceecfc768f1b$var$j($4c08ceecfc768f1b$var$g.ne.ye, $4c08ceecfc768f1b$var$n), $4c08ceecfc768f1b$var$E($4c08ceecfc768f1b$var$g.ne.we, $4c08ceecfc768f1b$var$i, 'true'), e.k ? ($4c08ceecfc768f1b$var$U(e.U), e.U = null) : ($4c08ceecfc768f1b$var$U(e.J), e.J = null), $4c08ceecfc768f1b$var$ee($4c08ceecfc768f1b$var$g.re._e, $4c08ceecfc768f1b$var$u));
};
var $4c08ceecfc768f1b$var$Ge = {
    show: $4c08ceecfc768f1b$export$57bf213be019eeb0,
    hide: $4c08ceecfc768f1b$export$fe8985bb6374093c,
    showPreferences: $4c08ceecfc768f1b$export$535e69674d40eb20,
    hidePreferences: $4c08ceecfc768f1b$export$5b3a895f6cbac580,
    acceptCategory: $4c08ceecfc768f1b$export$f733614a75aede52
};
const $4c08ceecfc768f1b$export$4b6bf64406ec64af = async (e, t)=>{
    if (!$4c08ceecfc768f1b$var$he(e)) return !1;
    const o = $4c08ceecfc768f1b$var$g.o;
    return !(e === $4c08ceecfc768f1b$var$Ce() && !0 !== t || !await $4c08ceecfc768f1b$var$Se(e) || ($4c08ceecfc768f1b$var$we(e), o.T && $4c08ceecfc768f1b$var$ye($4c08ceecfc768f1b$var$Ge, $4c08ceecfc768f1b$var$Me), o.N && $4c08ceecfc768f1b$var$me($4c08ceecfc768f1b$var$Ge, $4c08ceecfc768f1b$var$Me), $4c08ceecfc768f1b$var$xe(), 0));
}, $4c08ceecfc768f1b$export$ae3f5fa351e2f57a = ()=>{
    const { F: e, Y: t } = $4c08ceecfc768f1b$var$g.o, { accepted: o, rejected: n } = (()=>{
        const { D: e, R: t, O: o } = $4c08ceecfc768f1b$var$g.o;
        return {
            accepted: t,
            rejected: e ? [] : o.filter((e)=>!$4c08ceecfc768f1b$var$b(t, e))
        };
    })();
    return $4c08ceecfc768f1b$var$F({
        acceptType: e,
        acceptedCategories: o,
        rejectedCategories: n,
        acceptedServices: t,
        rejectedServices: $4c08ceecfc768f1b$var$P()
    });
}, $4c08ceecfc768f1b$export$2cb99e4be0dc4646 = (e, t)=>{
    let o = document.querySelector('script[src="' + e + '"]');
    return new Promise((n)=>{
        if (o) return n(!0);
        if (o = $4c08ceecfc768f1b$var$k('script'), $4c08ceecfc768f1b$var$h(t)) for(const e in t)$4c08ceecfc768f1b$var$E(o, e, t[e]);
        o.onload = ()=>n(!0), o.onerror = ()=>{
            o.remove(), n(!1);
        }, o.src = e, $4c08ceecfc768f1b$var$H(document.head, o);
    });
}, $4c08ceecfc768f1b$export$3cbc67a40c3171bd = (e)=>{
    let t, o = e.value, n = e.mode, a = !1;
    const s = $4c08ceecfc768f1b$var$g.o;
    if ('update' === n) {
        s.h = t = $4c08ceecfc768f1b$export$4be65e66cfa2648a('data');
        const e = typeof t == typeof o;
        if (e && 'object' == typeof t) {
            !t && (t = {});
            for(let e in o)t[e] !== o[e] && (t[e] = o[e], a = !0);
        } else !e && t || t === o || (t = o, a = !0);
    } else t = o, a = !0;
    return a && (s.h = t, s.p.data = t, $4c08ceecfc768f1b$var$ke(!0)), a;
}, $4c08ceecfc768f1b$export$4be65e66cfa2648a = (e, t)=>{
    const o = $4c08ceecfc768f1b$var$Ae(t);
    return e ? o[e] : o;
}, $4c08ceecfc768f1b$export$44487a86467333c3 = (e)=>{
    const t = $4c08ceecfc768f1b$var$g.t, o = $4c08ceecfc768f1b$var$g.o.i;
    return e ? t[e] || o[e] : {
        ...t,
        ...o,
        cookie: {
            ...t.cookie
        }
    };
}, $4c08ceecfc768f1b$export$3bdcc4c9b3764a39 = ()=>!$4c08ceecfc768f1b$var$g.o.D, $4c08ceecfc768f1b$export$889ea624f2cb2c57 = async (e)=>{
    const { o: o, t: n, re: a } = $4c08ceecfc768f1b$var$g, c = window;
    if (!c._ccRun) {
        if (c._ccRun = !0, ((e)=>{
            const { ne: o, t: n, o: a } = $4c08ceecfc768f1b$var$g, c = n, r = a, { cookie: i } = c, l = $4c08ceecfc768f1b$var$g.ce, d = e.cookie, f = e.categories, _ = $4c08ceecfc768f1b$var$w(f) || [], u = navigator, p = document;
            o.Ue = p, o.ye = p.documentElement, i.domain = location.hostname, r.i = e, r.P = f, r.O = _, r._ = e.language.translations, r.v = !!e.disablePageInteraction, l.ie = e.onFirstConsent, l.le = e.onConsent, l.de = e.onChange, l._e = e.onModalHide, l.fe = e.onModalShow, l.ue = e.onModalReady;
            const { mode: m, autoShow: v, lazyHtmlGeneration: y, autoClearCookies: C, revision: S, manageScriptTags: x, hideFromBots: M } = e;
            m === $4c08ceecfc768f1b$var$t && (c.mode = m), 'boolean' == typeof C && (c.autoClearCookies = C), 'boolean' == typeof x && (c.manageScriptTags = x), 'number' == typeof S && S >= 0 && (c.revision = S, r.V = !0), 'boolean' == typeof v && (c.autoShow = v), 'boolean' == typeof y && (c.lazyHtmlGeneration = y), !1 === M && (c.hideFromBots = !1), !0 === c.hideFromBots && u && (r.G = u.userAgent && /bot|crawl|spider|slurp|teoma/i.test(u.userAgent) || u.webdriver), $4c08ceecfc768f1b$var$h(d) && (c.cookie = {
                ...i,
                ...d
            }), c.autoClearCookies, r.V, c.manageScriptTags, ((e)=>{
                const { P: t, X: o, Y: n, Z: a, B: s } = $4c08ceecfc768f1b$var$g.o;
                for (let c of e){
                    const e = t[c], r = e.services || {}, i = $4c08ceecfc768f1b$var$h(r) && $4c08ceecfc768f1b$var$w(r) || [];
                    o[c] = {}, n[c] = [], a[c] = [], e.readOnly && (s.push(c), n[c] = i), $4c08ceecfc768f1b$var$g.ne.se[c] = {};
                    for (let e of i){
                        const t = r[e];
                        t.Se = !1, o[c][e] = t;
                    }
                }
            })(_), (()=>{
                if (!$4c08ceecfc768f1b$var$g.t.manageScriptTags) return;
                const e = $4c08ceecfc768f1b$var$g.o, t = $4c08ceecfc768f1b$var$D(document, 'script[' + $4c08ceecfc768f1b$var$s + ']');
                for (const o of t){
                    let t = $4c08ceecfc768f1b$var$N(o, $4c08ceecfc768f1b$var$s), n = o.dataset.service || '', a = !1;
                    if (t && '!' === t.charAt(0) && (t = t.slice(1), a = !0), '!' === n.charAt(0) && (n = n.slice(1), a = !0), $4c08ceecfc768f1b$var$b(e.O, t) && (e.oe.push({
                        Me: o,
                        xe: !1,
                        ke: a,
                        De: t,
                        Te: n
                    }), n)) {
                        const o = e.X[t];
                        o[n] || (o[n] = {
                            Se: !1
                        });
                    }
                }
            })(), $4c08ceecfc768f1b$var$we((()=>{
                const e = $4c08ceecfc768f1b$var$g.o.i.language.autoDetect;
                if (e) {
                    const t = {
                        browser: navigator.language,
                        document: document.documentElement.lang
                    }, o = $4c08ceecfc768f1b$var$he(t[e]);
                    if (o) return o;
                }
                return $4c08ceecfc768f1b$var$Ce();
            })());
        })(e), o.G) return;
        (()=>{
            const e = $4c08ceecfc768f1b$var$g.o, o = $4c08ceecfc768f1b$var$g.t, n = $4c08ceecfc768f1b$var$Ae(), { categories: a, services: s, consentId: c, consentTimestamp: r, lastConsentTimestamp: i, data: l, revision: d } = n, f = $4c08ceecfc768f1b$var$v(a);
            e.p = n, e.M = c;
            const _ = !!c && $4c08ceecfc768f1b$var$y(c);
            e.C = r, e.C && (e.C = new Date(r)), e.S = i, e.S && (e.S = new Date(i)), e.h = void 0 !== l ? l : null, e.V && _ && d !== o.revision && (e.I = !1), e.D = !(_ && e.I && e.C && e.S && f), o.cookie.useLocalStorage && !e.D && (e.D = (new Date).getTime() > (n.expirationTime || 0), e.D && $4c08ceecfc768f1b$var$De(o.cookie.name)), e.D, (()=>{
                const e = $4c08ceecfc768f1b$var$g.o;
                for (const o of e.O){
                    const n = e.P[o];
                    if (n.readOnly || n.enabled) {
                        e.$.push(o);
                        const n = e.X[o] || {};
                        for(let a in n)e.Z[o].push(a), e.i.mode === $4c08ceecfc768f1b$var$t && e.Y[o].push(a);
                    }
                }
            })(), e.D ? o.mode === $4c08ceecfc768f1b$var$t && (e.R = [
                ...e.$
            ]) : (e.Y = {
                ...e.Y,
                ...s
            }, e.Z = {
                ...e.Y
            }, $4c08ceecfc768f1b$var$G([
                ...e.B,
                ...a
            ]));
        })();
        const i = $4c08ceecfc768f1b$export$3bdcc4c9b3764a39();
        if (!await $4c08ceecfc768f1b$var$Se()) return !1;
        if ($4c08ceecfc768f1b$var$J(null, r = $4c08ceecfc768f1b$var$Ge, $4c08ceecfc768f1b$var$me, $4c08ceecfc768f1b$var$Me), $4c08ceecfc768f1b$var$g.o.D && $4c08ceecfc768f1b$var$ye(r, $4c08ceecfc768f1b$var$Me), $4c08ceecfc768f1b$var$g.t.lazyHtmlGeneration || $4c08ceecfc768f1b$var$me(r, $4c08ceecfc768f1b$var$Me), n.autoShow && !i && $4c08ceecfc768f1b$export$57bf213be019eeb0(!0), i) return $4c08ceecfc768f1b$var$oe(), $4c08ceecfc768f1b$var$ee(a.le);
        n.mode === $4c08ceecfc768f1b$var$t && $4c08ceecfc768f1b$var$oe(o.$);
    }
    var r;
}, $4c08ceecfc768f1b$export$aad8462122ac592b = (e)=>{
    const { Ce: t, ye: s } = $4c08ceecfc768f1b$var$g.ne, { name: c, path: r, domain: i, useLocalStorage: l } = $4c08ceecfc768f1b$var$g.t.cookie;
    e && (l ? $4c08ceecfc768f1b$var$De(c) : $4c08ceecfc768f1b$export$6dde6a4e31d2b3a6(c, r, i));
    for (const { pe: e, ge: t, me: o } of $4c08ceecfc768f1b$var$g.o.m)e.removeEventListener(t, o);
    t && t.remove(), s && s.classList.remove($4c08ceecfc768f1b$var$a, $4c08ceecfc768f1b$var$n, $4c08ceecfc768f1b$var$o);
    const d = new $4c08ceecfc768f1b$var$p;
    for(const e in $4c08ceecfc768f1b$var$g)$4c08ceecfc768f1b$var$g[e] = d[e];
    window._ccRun = !1;
};


// Ajouter un service dans le markup HTML:
// <script type="textplain" data-category="analytics" data-service="ga">Code GA ici</script>
// NOTE: textplain au lieu de text/plain: ça fonctionne idem et évite l'erreur parcel qui ne doit pas apprécier le "/"
// Enable dark mode
//document.documentElement.classList.add('cc--darkmode');
(0, $4c08ceecfc768f1b$export$889ea624f2cb2c57)({
    cookie: {
        useLocalStorage: true // Juste pour éviter des collisions entre vitroto.fr et {dev,test}.vitroto.fr
    },
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            // Défaut: enabled false, readonly false
            readOnly: true
        }
    },
    language: {
        default: "fr",
        translations: {
            fr: {
                consentModal: {
                    title: "\uD83C\uDF6A Nous utilisons des cookies !",
                    description: "Nous utilisons des cookies pour am\xe9liorer votre exp\xe9rience sur notre site, mesurer l\u2019audience et vous proposer des contenus adapt\xe9s \xe0 vos pr\xe9f\xe9rences. En cliquant sur \xab Accepter \xbb, vous consentez \xe0 leur utilisation.",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout rejeter",
                    showPreferencesBtn: "G\xe9rer les pr\xe9f\xe9rences",
                    footer: '<a href="/politique-de-confidentialite">Politique de confidentialit\xe9</a>\n<a href="/cgv">Termes et conditions</a>'
                },
                preferencesModal: {
                    title: "Pr\xe9f\xe9rences des cookies",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout rejeter",
                    savePreferencesBtn: "Sauvegarder les pr\xe9f\xe9rences",
                    closeIconLabel: "Fermer la modale",
                    serviceCounterLabel: "Services",
                    sections: [
                        {
                            title: "Personnalisez vos pr\xe9f\xe9rences de cookies \uD83C\uDF6A",
                            description: "Vous pouvez choisir les cat\xe9gories de cookies que vous souhaitez autoriser ou refuser. Les cookies n\xe9cessaires assurent le fonctionnement du site et ne peuvent pas \xeatre d\xe9sactiv\xe9s. S\xe9lectionnez ci-dessous vos pr\xe9f\xe9rences puis cliquez sur \xab Sauvegarder les pr\xe9f\xe9rences \xbb."
                        },
                        {
                            title: 'Cookies Strictement N\xe9cessaires <span class="pm__badge">Toujours Activ\xe9</span>',
                            description: "Ce site utilise un cookie de session, un cookie pour se rappeler de vous et enregistre les presents choix en mati\xe8re de cookies dans le localStorage, aucune de ces informations n'est identifiante.",
                            linkedCategory: "necessary"
                        },
                        /*
                        {
                            title: "Cookies Analytiques",
                            description: "Ces cookies permettent d'analyser le comportement général des utilisateurs du site.",
                            linkedCategory: "analytics",
			    cookieTable: {
                                headers: {
                                    name: "Nom",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Cookie mis en place par <a href=\"#das\">Google Analytics</a>",
                                        expiration: "Expire après 12 jours"
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Cookie mis en place par <a href=\"#das\">Google Analytics</a>",
                                        expiration: "Session"
                                    }
                                ]
                            }
                        },
			*/ {
                            title: "Plus d'informations",
                            // Todo: quand la page contact sera implémentée, ajouter le lien, ex:
                            //<a class=\"cc__link\" href=\"/contact\">contact me</a>
                            description: "Pour toute demande en relation avec la politique cookies et vos choix, veuillez nous contacter via le formulaire de contact."
                        }
                    ]
                }
            }
        }
    }
});


//# sourceMappingURL=404.5a7d55df.js.map
